import {
  computeReadableTextShade,
  DEFAULT_TEXT_CONTRAST_LIGHTNESS_THRESHOLD,
  normalizeHex,
  TextContrastShade,
} from './compute-readable-text-shade';

// Memoizes per (threshold, normalized hex) for the module's lifetime. Entity
// colors are a small, effectively fixed set, so unbounded growth is not a
// real concern for THIS consumer; callers passing arbitrary/unbounded color
// input should not rely on this cache being bounded.
const shadeCache = new Map<string, TextContrastShade>();

/**
 * Returns which text shade ('light' | 'dark') gives adequate contrast against
 * hexColor, via CIELAB L* (perceptual lightness). Accepts '#rgb', '#rgba',
 * '#rrggbb', '#rrggbbaa' (alpha ignored), case-insensitive, with or without a
 * leading '#'. Throws on invalid input. Result is cached per normalized hex
 * value and threshold.
 */
export function getReadableTextShade(
  hexColor: string,
  lightnessThreshold: number = DEFAULT_TEXT_CONTRAST_LIGHTNESS_THRESHOLD,
): TextContrastShade {
  const normalized = normalizeHex(hexColor);
  const cacheKey = `${lightnessThreshold}:${normalized}`;
  const cached = shadeCache.get(cacheKey);
  if (cached !== undefined) {
    return cached;
  }

  const shade = computeReadableTextShade(normalized, lightnessThreshold);
  shadeCache.set(cacheKey, shade);
  return shade;
}
